import { render, staticRenderFns } from "./sendIndex.vue?vue&type=template&id=bb97896c&scoped=true"
import script from "./sendIndex.vue?vue&type=script&lang=js"
export * from "./sendIndex.vue?vue&type=script&lang=js"
import style0 from "./sendIndex.vue?vue&type=style&index=0&id=bb97896c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb97896c",
  null
  
)

export default component.exports